import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { SUMMIT } from "@/constants/summit";
import { Reveal, SectionHeading } from "@/components/Reveal";

const HostSpotlight = () => (
  <section id="host" data-testid="host-spotlight-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <div>
          <SectionHeading index="06" kicker="Your Hosts" title="The Edutainment Box × DABO." />
          <Reveal delay={0.15}>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/60">
              Brought to you by The Edutainment Box, in collaboration with DABO Detroit — The Choice
              convenes Detroit's medical, investment, media and corporate leadership alongside South
              African smart-technology partners to decide the future of accessible healthcare.
            </p>
            <div className="mt-8 space-y-3">
              <a
                data-testid="host-contact-email"
                href={`mailto:${SUMMIT.contactEmail}`}
                className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-brand-300 hover:text-brand-400 transition-colors"
              >
                <Mail className="h-4 w-4" /> {SUMMIT.contactEmail}
              </a>
              <a
                data-testid="host-contact-phone"
                href={`tel:+1${SUMMIT.contactPhone.replace(/[^0-9]/g, "")}`}
                className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-brand-300 hover:text-brand-400 transition-colors"
              >
                <Phone className="h-4 w-4" /> {SUMMIT.contactName} · {SUMMIT.contactPhone}
              </a>
            </div>
          </Reveal>
        </div>
        <Reveal delay={0.2}>
          <div className="orange-glow relative overflow-hidden rounded-2xl border border-brand-500/40 bg-gradient-to-br from-brand-500 to-brand-700 p-10 sm:p-14">
            <span aria-hidden className="pointer-events-none absolute -bottom-10 -right-4 select-none font-display text-[11rem] font-black leading-none text-white/10">
              C
            </span>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-white/80">You are invited</p>
            <h3 className="mt-4 font-display text-3xl sm:text-4xl font-black leading-tight">
              Your seat at the table is waiting.
            </h3>
            <p className="mt-4 max-w-md text-sm sm:text-base text-white/80 leading-relaxed">
              {SUMMIT.dateLabel} · {SUMMIT.venue}, {SUMMIT.city}. Attendance is limited and
              strictly for invited VVIPs.
            </p>
            <Link
              to="/confirm-attendance"
              data-testid="host-cta-confirm-button"
              className="group mt-8 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 font-display text-sm font-bold text-brand-600 transition-all duration-300 hover:shadow-[0_0_40px_rgba(255,255,255,0.4)]"
            >
              Confirm Attendance
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default HostSpotlight;
